import { defineMessages } from 'react-intl';

export const messages: {
	connectAppTip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tipLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	proactiveTip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	connectAppTip: {
		id: 'ai-mate.conversation-assistant-chat-prompt-input.connector-source-connection-tip.connect-app-tip',
		defaultMessage: '<link>Connect {appName}</link> to enable access.',
		description:
			'Tip shown when user types an app name that is not yet connected. The link tag wraps the clickable portion that triggers the OAuth connection flow.',
	},
	tipLabel: {
		id: 'ai-mate.conversation-assistant-chat-prompt-input.connector-source-connection-tip.tip-label',
		defaultMessage: 'Tip:',
		description: 'Label shown before a connection suggestion tip',
	},
	proactiveTip: {
		id: 'ai-mate.conversation-assistant-chat-prompt-input.connector-source-connection-tip.proactive-tip',
		defaultMessage:
			'<link>Link your {appName} account</link> to unlock more context and richer details.',
		description:
			'Proactive tip shown in the context banner when SmartLinks are detected for an unconnected app. The link tag wraps the clickable portion that triggers the OAuth connection flow.',
	},
});
